export var fadedDiamondBackground = '$_2HI_U';
export var diamondDarkBackground = 'x4jhm';